<script>
    import MainContainer from '@/components/container/MainContainer.vue';

    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';

    import ButtonAnyNew from '@/components/left-panel/any-button/ButtonAnyNew.vue';
    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

    import SmartFilterList from '@/components/page-smart-filter/SmartFilterList.vue';
    import SmartFilterAdd from '@/components/page-smart-filter/smart-filter-add/SmartFilterAdd.vue';
    import SmartFilterEdit from '@/components/page-smart-filter/smart-filter-edit/SmartFilterEdit.vue';

    import { calculatePromise, promiseAll } from '@/api/default.js';

    export default {
        components: {
            MainContainer: MainContainer,

            LeftPanel: LeftPanel,
            RightContainer: RightContainer,

            ButtonAnyNew: ButtonAnyNew,
            ButtonReturn: ButtonReturn,

            SmartFilterList: SmartFilterList,
            SmartFilterAdd: SmartFilterAdd,
            SmartFilterEdit: SmartFilterEdit,
        },
        async mounted() {
            this.$store.commit('IS_LOAD', true);
            await this.$store.dispatch('CHECK_ASSET_TYPES');
            const promiseList = await calculatePromise([
                {dispatch: 'CHECK_PROVIDER_AXIOS', commit: 'PROVIDERS', isArray: false},
                {dispatch: 'CHECK_GAMES_AXIOS', commit: 'GAMES', isArray: false},
                {dispatch: 'CHECK_TAGS_AXIOS', commit: 'TAGS', isArray: false},
                {dispatch: 'CHECK_SMART_FILTER_AXIOS', commit: 'IMAGE_SMART_FILTERS', isArray: true},
                {dispatch: 'CHECK_FILTERS_AXIOS', commit: 'FILTERS_ADD', isArray: true}
            ]);
            await promiseAll(promiseList);
            this.$store.commit('IS_LOAD', false);
        },
        methods: {
            async toggleNewSmartFilter() {
                const isShow = this.$store.getters.IS_SHOW_SMART_FILTER_ADD;
                this.$store.commit('IS_SHOW_SMART_FILTER_ADD', !isShow);
                if (isShow === false) {
                    this.$store.dispatch('CHECK_SMART_FILTER_ADD');
                }
            },
        }
    }
</script>


<template>
    <SmartFilterAdd />
    <SmartFilterEdit />

    <MainContainer>
        <LeftPanel>
            <ButtonAnyNew
                title="New Smart Filter"
                :method="toggleNewSmartFilter"
            />
            <hr class="left-separator">
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <SmartFilterList />
        </RightContainer>
    </MainContainer>
</template>